import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../stores/userStore';
import { TITLES, type TitleDefinition } from '@beast-keeper/shared';

export default function TitleHallScreen() {
  const navigate = useNavigate();
  const unlockedTitles = useUserStore((s) => s.unlockedTitles);
  const unlockedSet = new Set(unlockedTitles);
  const [previewTitle, setPreviewTitle] = useState<TitleDefinition | null>(null);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, padding: 'var(--space-lg) var(--space-md)' }}>
      <div className="top-bar">
        <button className="btn-back" onClick={() => navigate('/')} aria-label="返回首页">←</button>
        <div className="title">📜 名号殿堂</div>
      </div>

      <div className="scroll-area">
        <div className="th-grid">
          {TITLES.map((t) => {
            const unlocked = unlockedSet.has(t.name);
            return (
              <div
                key={t.name}
                className={`th-card${unlocked ? ' unlocked' : ' locked'}`}
                onClick={() => setPreviewTitle(t)}
              >
                <span className="th-icon">{t.icon}</span>
                <div className="th-body">
                  <div className="th-name">
                    {t.name} {unlocked ? '✅' : ''}
                  </div>
                  <div className="th-quote">"{t.quote}"</div>
                </div>
                <span className="th-range">{t.min}~{t.max}分</span>
              </div>
            );
          })}
        </div>
      </div>

      {previewTitle && (
        <div className="modal-overlay show" onClick={() => setPreviewTitle(null)}>
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <span style={{ fontSize: '4rem', display: 'block', marginBottom: 'var(--space-md)' }}>
              {previewTitle.icon}
            </span>
            <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
              {previewTitle.name}
              {unlockedSet.has(previewTitle.name) && <span>✅</span>}
            </h3>
            <p className="hint">"{previewTitle.quote}"</p>
            <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem' }}>
              分数区间：{previewTitle.min} ~ {previewTitle.max} 分
            </p>
            {!unlockedSet.has(previewTitle.name) && (
              <p style={{ color: 'var(--color-accent)', fontSize: '0.85rem', marginTop: 'var(--space-sm)' }}>
                🔒 尚未解锁，继续答题获取此名号吧！
              </p>
            )}
            <button
              className="btn btn-primary"
              style={{ marginTop: 'var(--space-lg)', width: '100%' }}
              onClick={() => setPreviewTitle(null)}
            >
              知道了
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
